import Keycloak from "keycloak-js";

interface EnvConfig {
	url: string;
	realm: string;
	clientId: string;
}

// One Keycloak per public hostname. The same Docker image is deployed to dev /
// stage / prod with different API_* env vars, but the JS bundle is baked at build
// time, so we pick the right realm here from window.location.hostname. dev +
// stage hit the STG cluster's KC; prod + ref hit the PRD cluster's KC (separate
// realm, same name "ayvens").
const envByHost: Record<string, EnvConfig> = {
	"logistics.dev.ald.digital": {
		url: "https://auth.stage.cluster.ayvens.digital",
		realm: "ayvens",
		clientId: "carlos",
	},
	"logistics.stage.ald.digital": {
		url: "https://auth.stage.cluster.ayvens.digital",
		realm: "ayvens",
		clientId: "carlos",
	},
	"logistics.ald.digital": {
		url: "https://auth.cluster.ayvens.digital",
		realm: "ayvens",
		clientId: "carlos",
	},
	"logistics.ref.ald.digital": {
		url: "https://auth.cluster.ayvens.digital",
		realm: "ayvens",
		clientId: "carlos",
	},
	localhost: {
		url: "https://auth.stage.cluster.ayvens.digital",
		realm: "ayvens",
		clientId: "carlos",
	},
};

const config = envByHost[window.location.hostname] ?? envByHost.localhost;

const client = new Keycloak({
	url: config.url,
	realm: config.realm,
	clientId: config.clientId,
});

export default {
	createClient() {
		return client;
	},
	getConfig() {
		return config;
	},
};
